import { StarFilled, StarOutlined } from "@ant-design/icons";
import CardChevron from "@/Components/Common/CardChevron";
import React from "react";
import { useIntl } from "react-intl";
import { ISelectItemProps } from "../../../Orchestrator/Types/Index";
import { getIconForType } from "./GetIconForType";
import stopManager from "../../../Lib/Utils/StopManager";

const SelectItem: React.FC<ISelectItemProps> = ({
  item,
  isOpen,
  isFavorite,
  onClick,
  onToggleFavorite,
  onToggleDropdown,
  isDisplayFavorite = true,
}) => {
  const intl = useIntl();
  const renderStar = () => {
    return <StarOutlined className="color-CCCCCC h-20 w-20" />;
  };
  return (
    <div
      className="location-item"
      onClick={() =>
        item.subStations.length > 0
          ? onToggleDropdown(item?.name)
          : onClick(item.name)
      }
      style={{
        borderColor: isOpen ? "black" : "#ddd",
      }}
      data-id={`location-item-${item.name}`}
      aria-expanded={item.subStations.length > 0 ? isOpen : undefined}
    >
      <span className="align-items-center fw-500 fs-16">
        {getIconForType(
          item.subStations.length > 0 ? "direction" : item?.type || ""
        )}
        {stopManager.getStopNameById(item.id || item.name)}
      </span>

      {item.subStations.length > 0 && (
        <span
          onClick={(e) => {
            e.stopPropagation();
            onToggleDropdown(item.name);
          }}
        >
          <CardChevron
            direction={isOpen ? "up" : "down"}
            width={10}
            height={10}
            className="mr-8"
          />
        </span>
      )}
      {item.subStations.length === 0 && isDisplayFavorite && (
        <span
          onClick={(e) => {
            e.stopPropagation();
            onToggleFavorite(item.id || "", e);
          }}
          data-id={`favorite-icon-${item.name}`}
        >
          {isFavorite ? (
            <StarFilled className="color-primary h-20 w-20" />
          ) : (
            renderStar()
          )}
        </span>
      )}
    </div>
  );
};

export default SelectItem;
